
define('template!ordersReviewView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="status review" title="Review">\n  <i class="mdi-maps-rate-review"></i>\n</div>';

}
return __p
};});

